import { Controller, useWatch } from "react-hook-form";
import Select from "react-select";

const customStyles = {
    multiValue: (baseStyles, { data }) => ({
        ...baseStyles,
        backgroundColor: data.bgColor || 'var(--lighterGrey)', // Use the color defined in your option data
    }),
    multiValueLabel: (baseStyles, { data }) => ({
        ...baseStyles,
        color: data.color || 'var(--black)' //'var(--black)', // Set the text color to white for better contrast
    }),
};

const getNestedError = (errors, name) =>
    name?.split(".").reduce((acc, key) => (acc == null ? acc : acc[key]), errors);

const FormSelect = ({
    style,
    label,
    name,
    control,
    options,
    errors,
    placeholder = 'select...',
    onSelectedHandler,
    onBlurHandler,
    disabled,
    isClearable = true,
    isMulti,
    components,
    required = false,
}) => {
    const value = useWatch({
        control,
        name, // The name of the field you want to watch
    });

    const fieldError = getNestedError(errors, name);

    return (
        <div className="form-input" style={style}>
            <label>
                {label}
                {required ? (
                    <>
                        {" "}
                        <span className="danger">*</span>
                    </>
                ) : null}
            </label>
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <Select
                        {...field}
                        styles={customStyles}
                        options={options}
                        className="react-select-container"
                        classNamePrefix="react-select"
                        placeholder={placeholder}
                        isClearable={isClearable}
                        isDisabled={disabled}
                        isMulti={isMulti}
                        menuPlacement="auto"
                        components={components}
                        value={value}
                        onChange={async (val) => {
                            field.onChange(val);
                            await onSelectedHandler?.(val)
                        }}
                        onBlur={(event) => {
                            field.onBlur();
                            onBlurHandler?.(event);
                        }}
                    />
                )}
            />
            {fieldError?.message && <p style={{ color: "var(--red)", paddingTop: ".4rem" }}>{fieldError.message}</p>}
        </div>
    )
}

export default FormSelect
